export default "__VITE_ASSET__CTZH4BwK__"